import { RPC_URLS, APP_CHAIN } from '@/client/confs/app';
import { createPublicClient, fallback, http } from 'viem';

export const publicClient = createPublicClient({
  chain: APP_CHAIN,
  // No rank probe (it sent net_listening to every RPC each 60 s from each tab).
  // Each request still fails over in RPC_URLS order; a node that hangs costs
  // 5 s before the next one is tried (viem default: 10 s).
  transport: fallback(
    RPC_URLS.map(url => http(url, { timeout: 5_000 })),
    { rank: false }
  ),
  batch: {
    multicall: {
      batchSize: 1024 * 200,
      wait: 50,
    },
  },
});
